
























































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/requestExt'
import navigater from '@/components/navigater.vue'
// import swiper from '@/components/swiper.vue'

export default Vue.extend({
    components: {
        navigater,
    },
    data() {
        return {
            loading: true,
            navTitle: '',
            id: '',
            imageData: [
                // {imgUrl: '/static/image/null.png'},
                // {imgUrl: '/static/image/null.png'},
                // {imgUrl: '/static/image/null.png'},
            ],
            dataObj: {},
            evaluateData: [],
        }
    },
    created() {
        // console.log(this.$route.params.id)
        this.id = this.$route.params.id
        this.getData(this.id)
        this.getEvaluate(this.id)
    },
    methods: {
        getData(id: any) {
            request.get(`/api/course_ware/${id}`).then((result) => {
                console.log(result)
                this.navTitle = result.name // 课程名称
                const preview = {
                    imgUrl: result.preview,
                }
                // @ts-ignore
                this.imageData.push(preview)
                this.dataObj = result
                this.loading = false
            }).catch((err) => {
                console.log(err)
                this.loading = false
            })
        },

        getEvaluate(id: any) {
            const params = {
                courseWareId: id,
                showStatus: 1,
                orderBy: 'create_time desc',
            }
            request.get(`/api/courseWareEva`, params).then((result) => {
                console.log(result)
                this.evaluateData = result

            }).catch((err) => {
                console.log(err)
            })
        },

        goEvaluate() {
            this.$router.push({ path: `/kejian_evaluate/${this.id}` })
        },
        download(item: any) {
            window.open(item, '_blank');
        },
    },
    filters: {
        getTime(value: any) {
            if (value) {
                return moment(value).format('YYYY/MM/DD HH:mm:ss')
            } else {
                return '- -'
            }
        },
    },
})
